import script from "./compiled-rezzie-text.vue?vue&type=script&lang=js"
export * from "./compiled-rezzie-text.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__